export { default } from './PastDuePayments.data';
